module.exports = __webpack_public_path__ + "static/img/cert-empty.9dd0d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cert-empty.png
// module id = ndqQ
// module chunks = 0